function required(key: string): string {
  const value = import.meta.env[key as keyof ImportMetaEnv] as string | undefined;
  if (!value) {
    throw new Error(`Missing required env var: ${key}`);
  }
  return value;
}

function optional(key: string): string {
  return (import.meta.env[key as keyof ImportMetaEnv] as string | undefined) ?? "";
}

export const ENV = {
  API_URL: required("VITE_API_URL"),
  FIREBASE: {
    API_KEY: required("VITE_FIREBASE_API_KEY"),
    AUTH_DOMAIN: required("VITE_FIREBASE_AUTH_DOMAIN"),
    PROJECT_ID: required("VITE_FIREBASE_PROJECT_ID"),
    APP_ID: required("VITE_FIREBASE_APP_ID"),
  },
  FIREBASE_AUTH_EMULATOR_HOST: optional("VITE_FIREBASE_AUTH_EMULATOR_HOST"),
  MS_TENANT_ID: optional("VITE_MS_TENANT_ID"),
} as const;
